'use client';

import { useIsMobile } from "@/hooks/use-is-mobile";
import { ChevronDown, MailIcon, PhoneCallIcon } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import { useTranslations } from "next-intl";
import { appConfig } from "@/app-config";

const phone = appConfig.contacts.phone;
const phoneMob = appConfig.contacts.phone_mob;
const email = appConfig.contacts.email;

const TopBarContacts = () => {
  const t = useTranslations();
  const isMobile = useIsMobile();

  return (
    isMobile ? (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="inline-flex items-center gap-2">
            <PhoneCallIcon className="h-4 w-4" aria-hidden />
            <span>{t('contacts')}</span>
            <ChevronDown className="h-4 w-4" aria-hidden />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-56 ml-2">
          <DropdownMenuItem asChild>
            <a href={`tel:${phone}`} className="flex items-center gap-2">
              <PhoneCallIcon className="h-4 w-4" aria-hidden /> {phone}
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a href={`tel:${phoneMob}`} className="flex items-center gap-2">
              <PhoneCallIcon className="h-4 w-4" aria-hidden /> {phoneMob}
            </a>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <a href={`mailto:${email}`} className="flex items-center gap-2">
              <MailIcon className="h-4 w-4" aria-hidden /> {email}
            </a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    ) : (
      <div className="flex flex-row space-x-4 md:space-x-6 lg:space-x-10">
        <div className="flex flex-row items-center gap-2">
          <PhoneCallIcon className="w-4 h-4" aria-hidden />
          <a href={`tel:${phone}`} className="hover:underline">{phone}</a>
        </div>
        <div className="flex flex-row items-center gap-2">
          <PhoneCallIcon className="w-4 h-4" aria-hidden />
          <a href={`tel:${phoneMob}`} className="hover:underline">{phoneMob}</a>
        </div>
        <div className="flex flex-row items-center gap-2">
          <MailIcon className="w-4 h-4" aria-hidden />
          <a href={`mailto:${email}`} className="hover:underline">{email}</a>
        </div>
      </div>
    )
  );
};

export default TopBarContacts;
